<template>
	<Popup v-model="selfDisplay" title="修改	" confirmBtnText="修改" @confirmClick="handleUpdateClick">
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>订单号</span>
				<el-input :value="number" disabled></el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>流水号</span>
				<div class="b_block" style="width: 200px;">
					<el-input :value="serial" disabled></el-input>
				</div>
				<div class="b_block" style="width: 70px;margin-left: 20px;">
					<el-button class="clipboard" type="primary" :data-clipboard-text="obj.serial">复制</el-button>
				</div>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>价格</span>
				<el-input :value="price" disabled>
					<template slot="prepend">￥</template>
				</el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>支付总额</span>
				<el-input :value="amount" disabled>
					<template slot="prepend">￥</template>
				</el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>数量</span>
				<el-input :value="num" disabled>
					<template slot="prepend">个</template>
				</el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>收货地址</span>
				<el-input :value="addr" disabled></el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>店铺名称</span>
				<el-input :value="shopName" disabled></el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>购买账户</span>
				<el-input :value="uCode" disabled></el-input>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>下单时间</span>
				<el-date-picker :value="date" :editable="false" disabled type="date" value-format="yyyy-MM-dd"
					@change="handleDateChange">
				</el-date-picker>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>发货状态</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="sendStatus">
						<el-radio v-for="v in appSendStatus" :key="v.id" :label="v.id">{{ v.name }}</el-radio>
					</el-radio-group>
				</div>
			</div>

			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>订单状态</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="orderStatus">
						<el-radio v-for="v in appOrderStatus" :key="v.id" :label="v.id">{{ v.name }}</el-radio>
					</el-radio-group>
				</div>
			</div>

			<div v-if="goodsId == 10039" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>滤波镜片</span>
				<el-input :value="level" disabled></el-input>
			</div>

			<div v-if="goodsId == 10039" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>近视镜片</span>
				<el-input :value="specification" disabled></el-input>
			</div>

			<div v-if="goodsId == 10039" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>镜架</span>
				<el-input :value="frame" disabled></el-input>
			</div>

			<div v-if="goodsId == 10039" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>增值服务</span>
				<el-input :value="valueAddedName" disabled></el-input>
			</div>

			<div v-if="goodsId == 10039" class="base_form_row clear_both" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>屈光度数</span>
				<div class="b_block" style="width: 245px;margin-right: 23px;">
					<div style="font-size: 14px;line-height: 36px;">右眼</div>
					<el-input v-model="refractionR" placeholder="请输入0-9999的整数"></el-input>
					<div class="base_tip"><template v-if="refractionRTip"><i
								class="b_icon"></i>屈光度数右眼应为0-9999的整数</template></div>
				</div>
				<div class="b_block" style="width: 245px;">
					<div style="font-size: 14px;line-height: 36px;">左眼</div>
					<el-input v-model="refractionL" placeholder="请输入0-9999的整数"></el-input>
					<div class="base_tip"><template v-if="refractionLTip"><i
								class="b_icon"></i>屈光度数左眼应为0-9999的整数</template></div>
				</div>
			</div>

			<div v-if="goodsId == 10039" class="base_form_row clear_both">
				<span class="b_label"><span style="color: #f00;">*</span>散光</span>
				<div class="b_block" style="width: 245px;margin-right: 23px;">
					<div style="font-size: 14px;line-height: 36px;">右眼</div>
					<el-input v-model="astigmatismR" placeholder="请输入0-9999的整数"></el-input>
					<div class="base_tip"><template v-if="astigmatismRTip"><i
								class="b_icon"></i>散光右眼应为0-9999的整数</template></div>
				</div>
				<div class="b_block" style="width: 245px;">
					<div style="font-size: 14px;line-height: 36px;">左眼</div>
					<el-input v-model="astigmatismL" placeholder="请输入0-9999的整数"></el-input>
					<div class="base_tip"><template v-if="astigmatismLTip"><i
								class="b_icon"></i>散光左眼应为0-9999的整数</template></div>
				</div>
			</div>

			<div v-if="goodsId == 10039" class="base_form_row clear_both">
				<span class="b_label"><span style="color: #f00;">*</span>轴位</span>
				<div class="b_block" style="width: 245px;margin-right: 23px;">
					<div style="font-size: 14px;line-height: 36px;">右眼</div>
					<el-input v-model="axialR" placeholder="请输入0-9999的整数"></el-input>
					<div class="base_tip"><template v-if="axialRTip"><i class="b_icon"></i>轴位右眼应为0-9999的整数</template>
					</div>
				</div>
				<div class="b_block" style="width: 245px;">
					<div style="font-size: 14px;line-height: 36px;">左眼</div>
					<el-input v-model="axialL" placeholder="请输入0-9999的整数"></el-input>
					<div class="base_tip"><template v-if="axialLTip"><i class="b_icon"></i>轴位左眼应为0-9999的整数</template>
					</div>
				</div>
			</div>

			<div v-if="goodsId == 10039" class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>瞳距</span>
				<el-input v-model="distance" placeholder="请输入0-100的数"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="distanceTip"><i
						class="b_icon"></i>瞳距应为0-100</template></div>

			<div v-if="goodsId == 10039" class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>训练师确认</span>
				<div class="b_checkbox_group">
					<el-radio-group v-model="affirm">
						<el-radio :label="0">未确认</el-radio>
						<el-radio :label="1">确认</el-radio>
					</el-radio-group>
				</div>
			</div>

			<div v-if="orderStatus == 5" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">退款原因</span>
				<el-input v-model="refundReason" placeholder="退款原因"></el-input>
			</div>

			<div v-if="orderStatus == 5" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">退款备注</span>
				<el-input v-model="refundRemark" placeholder="退款备注"></el-input>
			</div>
		</div>
	</Popup>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	import Api from '../../../../../../../api/index.js';

	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default () {
					return {};
				}
			}
		},
		mounted() {
			this.clipboardInstance = null;
			this.display && (this.selfDisplay = true);
		},
		data() {
			return {
				loading: false,
				selfDisplay: false,

				goodsId: -1,
				number: '',
				serial: '',
				price: '',
				amount: '',
				num: '',
				addr: '',
				shopName: '',
				uCode: '',
				date: '',
				sendStatus: '',
				orderStatus: '',
				level: '',
				specification: '',
				frame: '',
				valueAddedName: '',
				valueAddedId: '',
				refractionR: '',
				refractionL: '',
				astigmatismR: '',
				astigmatismL: '',
				axialR: '',
				axialL: '',
				distance: '',
				affirm: 0,
				refundReason: '',
				refundRemark: '',
				refractionRTip: false,
				refractionLTip: false,
				astigmatismRTip: false,
				astigmatismLTip: false,
				axialRTip: false,
				axialLTip: false,
				distanceTip: false
			}
		},
		computed: {
			...mapState([
				'appSendStatus',
				'appOrderStatus'
			])
		},
		methods: {
			// 点击修改
			handleUpdateClick() {
				const that = this;
				that.loading = true;
				if (that.goodsId == 10039) {
					if (!that.positiveReg.test(that.refractionR) || parseInt(that.refractionR) > 9999) {
						console.log(that.positiveReg.test(that.refractionR))
						console.log(parseInt(that.refractionR))
						that.refractionRTip = true;
						return false;
					} else {
						that.refractionRTip = false;
					}

					if (!that.positiveReg.test(that.refractionL) || parseInt(that.refractionL) > 9999) {
						that.refractionLTip = true;
						return false;
					} else {
						that.refractionLTip = false;
					}
					if (!that.positiveReg.test(that.astigmatismR) || parseInt(that.astigmatismR) > 9999) {
						that.astigmatismRTip = true;
						return false;
					} else {
						that.astigmatismRTip = false;
					}
					if (!that.positiveReg.test(that.astigmatismL) || parseInt(that.astigmatismL) > 9999) {
						that.astigmatismLTip = true;
						return false;
					} else {
						that.astigmatismLTip = false;
					}
					if (!that.positiveReg.test(that.axialR) || parseInt(that.axialR) > 9999) {
						that.axialRTip = true;
						return false;
					} else {
						that.axialRTip = false;
					}
					if (!that.positiveReg.test(that.axialL) || parseInt(that.axialL) > 9999) {
						that.axialLTip = true;
						return false;
					} else {
						that.axialLTip = false;
					}
					if (!that.floatReg.test(that.distance) || parseInt(that.distance) > 100 || parseInt(that.distance) <
						0) {
						that.distanceTip = true;
						return false;
					} else {
						that.distanceTip = false;
					}
				}

				console.log("8")
				let requestData = {
					orderId: that.obj.id,
					orderPayStatus: that.orderStatus,
					typeChannel: 2,
					sendFlag: that.sendStatus,
					returnReason: that.refundReason,
					returnRemark: that.refundRemark,
					returnMoney: that.amount,
					levelName: that.level,
					spectaclesFrameId: that.obj.frameId,
					valueAddedName: that.obj.valueAddedName,
					valueAddedId: that.obj.valueAddedId,
					specificationsId: that.obj.specificationId,
					diopterRight: that.refractionR,
					diopterLeft: that.refractionL,
					astigmatismRight: that.astigmatismR,
					astigmatismLeft: that.astigmatismL,
					axialLeft: that.axialL,
					axialRight: that.axialR,
					pupillaryDistance: that.distance,
					affirm: that.affirm
				};
				console.log("123")
				Api.updateOrderForAppAndMall(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 选择训练时间
			handleDateChange() {
				if (this.date) {
					var destTime = new Date(this.date).getTime(),
						nowTime = new Date().getTime();
					if (destTime > nowTime) {
						this.$message.warning('下单时间不能超过当天');
						this.add_date = '';
					} else {
						this.getWithTrainingInfoByDate('add');
					}
				}
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				const that = this;
				that.$emit("changeDisplay", newVal);
				if (newVal) {
					that.loading = false;
					that.goodsId = that.obj.goodsId;
					that.number = that.obj.number;
					that.serial = that.obj.serial;
					that.price = that.obj.price;
					that.amount = that.obj.amount;
					that.num = that.obj.num;
					that.addr = that.obj.addr;
					that.shopName = that.obj.shopName;
					that.uCode = that.obj.uCode;
					that.date = that.obj.time;
					that.sendStatus = that.obj.sendValue;
					that.orderStatus = that.obj.orderStatusValue;
					that.level = that.obj.level;
					that.specification = that.obj.specificationLabel;
					that.frame = that.obj.frameLabel;
					that.valueAddedName = that.obj.valueAddedName;
					that.refractionR = that.obj.refractionR;
					that.refractionL = that.obj.refractionL;
					that.astigmatismR = that.obj.astigmatismR;
					that.astigmatismL = that.obj.astigmatismL;
					that.axialR = that.obj.axialR;
					that.axialL = that.obj.axialL;
					that.distance = that.obj.distance;
					that.affirm = that.obj.affirm;
					that.refundReason = '';
					that.refundRemark = '';
					that.refractionRTip = false;
					that.refractionLTip = false;
					that.astigmatismRTip = false;
					that.astigmatismLTip = false;
					that.axialRTip = false;
					that.axialLTip = false;
					that.distanceTip = false;
					that.clipboardInstance = new that.Clipboard('.clipboard');
					that.clipboardInstance.on('success', () => {
						that.$message.success('复制成功');
					});
				} else {
					that.clipboardInstance && that.clipboardInstance.destroy();
				}
			}
		}
	}
</script>

<style>
</style>
